<div class="table mt-0100 entityIdTable"
     *ngIf="entity">
  <div class="tr tr--noGutter tile__heading">
    Entity IDs
  </div>
  <div class="tr trContact">
    <div class="tc trContact__title"
         style="min-width: 100px;">Action Builder ID</div>
    <div class="tc tc--xs trContact__type">
      <span class="c-pointer"
            matTooltip="Click to copy to clipboard"
            aria-label="Click to copy to clipboard"
            aria-roledescription="Copy to clipboard button"
            [cdkCopyToClipboard]="entity.actionBuilderId"
            (cdkCopyToClipboardCopied)="copied()">{{entity.actionBuilderId}}</span>
    </div>
  </div>
  <ng-container *ngFor="let id of customIds">
    <div class="tr trContact"
         *ngIf="id.value">
      <div class="tc trContact__title"
           style="min-width: 100px;">{{id.customIdType.label}}</div>
      <div class="tc tc--xs trContact__type">
        <span class="c-pointer"
              matTooltip="Click to copy to clipboard"
              aria-label="Click to copy to clipboard"
              aria-roledescription="Copy to clipboard button"
              [cdkCopyToClipboard]="id.value"
              (cdkCopyToClipboardCopied)="copied()">{{id.value}}</span>
      </div>
      <ng-container *appIfMinRole="'administrator'">
        <div class="tr__drawer tr__drawer--sm drawer">
          <button class="drawer__btn"
                  type="button"
                  [matMenuTriggerFor]="customId"
                  #menuTrigger>
            <i class="far fa-fw fa-ellipsis-h fa--gray"></i>
          </button>
          <mat-menu class="popover__menu ignore-click"
                    #customId="matMenu">
            <button mat-menu-item
                    (click)="openDialog(id)">
              Edit
            </button>

            <button mat-menu-item
                    (click)="openDeleteDialog(id)">
              <span class="link link--noline link--red">Delete</span>
            </button>
          </mat-menu>
        </div>
      </ng-container>
    </div>
  </ng-container>
</div>
